<template>
  <div class="max-h-screen overflow-y-auto xl:pb-1 pb-10">
    <!-- Summary Header -->
    <div class="bg-gradient-to-r from-green-50 to-emerald-50 dark:from-gray-800 dark:to-gray-700 p-4 rounded-lg mb-4">
      <div class="grid grid-cols-4 gap-4 text-center">
        <div class="bg-white dark:bg-gray-800 p-3 rounded-lg shadow-sm">
          <div class="text-2xl font-bold text-blue-600">{{ List.length }}</div>
          <div class="text-sm text-gray-600 dark:text-gray-300">Atanan Araç</div>
        </div>
        <div class="bg-white dark:bg-gray-800 p-3 rounded-lg shadow-sm">
          <div class="text-2xl font-bold text-green-600">{{ List.filter(v => v.isCustom === 1).length }}</div>
          <div class="text-sm text-gray-600 dark:text-gray-300">Manuel Atama</div>
        </div>
        <div class="bg-white dark:bg-gray-800 p-3 rounded-lg shadow-sm">
          <div class="text-2xl font-bold text-purple-600">{{ List.filter(v => v.isCustom !== 1).length }}</div>
          <div class="text-sm text-gray-600 dark:text-gray-300">Otomatik Öneri</div>
        </div>
        <div class="bg-white dark:bg-gray-800 p-3 rounded-lg shadow-sm">
          <div class="text-2xl font-bold text-orange-600">{{ List.reduce((sum, v) => sum + (v.allCost || 0), 0).toFixed(0) }}₺</div>
          <div class="text-sm text-gray-600 dark:text-gray-300">Toplam Maliyet</div>
        </div>
      </div>
      
      <!-- Bulk Actions -->
      <div v-if="selectedItems.length > 0" class="mt-4 flex items-center justify-between bg-red-50 dark:bg-red-900/20 p-3 rounded-lg border border-red-200 dark:border-red-800">
        <div class="flex items-center">
          <i class="fas fa-check-circle text-red-500 mr-2"></i>
          <span class="text-sm font-medium text-red-700 dark:text-red-300">{{ selectedItems.length }} araç seçildi</span>
        </div>
        <div class="flex space-x-2">
          <button
            type="button"
            @click="clearSelection"
            class="px-3 py-1 text-xs bg-gray-500 hover:bg-gray-600 text-white rounded-md transition-colors duration-200"
          >
            Seçimi Temizle
          </button>
          <button
            type="button"
            @click="bulkDelete"
            class="px-3 py-1 text-xs bg-red-500 hover:bg-red-600 text-white rounded-md transition-colors duration-200"
          >
            <i class="fas fa-trash mr-1"></i>Seçilenleri Sil
          </button>
        </div>
      </div>
    </div>
    
    <div
      class="shadow overflow-x-scroll border border-gray-200 bg-white dark:bg-gray-900 rounded-xl mb-4 h-80"
    >
      <vehicleModal :detail="selected" />
      <vehicle-conflict-modal @close="reset" :visible="isVehicleConflictModalVisible.show" :orderInfo="isVehicleConflictModalVisible.order" :vehicleInfo="isVehicleConflictModalVisible.vehicle" />
      <table class="min-w-full divide-y divide-gray-200">
        <thead
          class="bg-gradient-to-r from-gray-50 to-gray-100 dark:from-gray-700 dark:to-gray-800"
        >
          <tr>
            <th
              scope="col"
              class="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider border-r border-gray-200 dark:border-gray-600"
              style="min-width: 70px !important"
            >
              <input
                type="checkbox"
                :checked="allSelected"
                @change="toggleAllSelection"
                class="rounded border-gray-300 text-blue-600 focus:ring-blue-500"
              >
              <span class="ml-2">#</span>
            </th>
            <th
              scope="col"
              class="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider border-r border-gray-200 dark:border-gray-600"
              style="min-width: 280px !important"
            >
              <i class="fas fa-file-invoice mr-1"></i>Sipariş
            </th>
            <th
              scope="col"
              class="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider border-r border-gray-200 dark:border-gray-600"
              style="min-width: 280px !important"
            >
              <i class="fas fa-truck mr-1"></i>Araç
            </th>
            <th
              scope="col"
              class="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider border-r border-gray-200 dark:border-gray-600"
              style="min-width: 180px !important"
            >
              <i class="fas fa-map-marker-alt mr-1"></i>Konum
            </th>
            <th
              scope="col"
              class="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider border-r border-gray-200 dark:border-gray-600"
              style="min-width: 180px !important"
            >
              <i class="fas fa-tint mr-1"></i>Yıkama Noktası
            </th>
            <th
              scope="col"
              class="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider border-r border-gray-200 dark:border-gray-600"
              style="min-width: 100px !important"
            >
              <i class="fas fa-hand-holding-usd mr-1"></i>Yıkama
            </th>
            <th
              scope="col"
              class="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider border-r border-gray-200 dark:border-gray-600"
              style="min-width: 100px !important"
            >
              <i class="fas fa-road mr-1"></i>Sefer
            </th>
            <th
              scope="col"
              class="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider border-r border-gray-200 dark:border-gray-600"
              style="min-width: 100px !important"
            >
              <i class="fas fa-calculator mr-1"></i>Toplam
            </th>
            <th
              v-if="!hiddenInsert"
              scope="col"
              class="px-4 py-3 text-left text-xs font-semibold text-gray-700 dark:text-gray-300 uppercase tracking-wider"
              style="min-width: 90px !important"
            >
              <i class="fas fa-cogs mr-1"></i>İşlemler
            </th>
          </tr>
        </thead>
        <tbody
          v-if="!isMultipleDay"
          class="divide-y-2 divide-gray-500"
          style="background-color: #3a3a3a"
        >
          <newVehicle
            v-if="changeState == false && !hiddenInsert"
            @addItem="(r) => addItem(r)"
            :order="orders"
            :products="products"
            :customers="customers"
            :vehicleList="vehicleList"
            :selectedVehicles="List"
            :hiddenInsert="hiddenInsert"
            @isVehicleConflictModalVisible="(event)=>isVehicleConflictModalVisible=event"
          />

          <tr
            v-show="
              (!changeState || List?.length > 0) &&
              !load &&
              !isRecommendationInProgress
            "
            v-for="(item, index) in List"
            :key="index"
            @click="toggleRowSelection(item, index, $event)"
            :class="{
              'bg-gray-700 dark:bg-blue-900/20 border-l-4': isSelected(item, index),
              'border-l-blue-500': isSelected(item, index) && item.isCustom !== 1,
              'border-l-green-500': isSelected(item, index) && item.isCustom === 1
            }"
            class="cursor-pointer transition-all duration-200 select-none"
          >
            <td class="table-td border-r border-opacity-20">
              <div class="flex items-center">
                <input
                  type="checkbox"
                  :value="item.id || index"
                  v-model="selectedItems"
                  @click.stop
                  class="rounded border-gray-300 text-blue-600 focus:ring-blue-500 mr-2"
                >
                <span># {{ index + 1 }}</span>
              </div>
            </td>

            <td class="table-td border-r border-opacity-20">
              <span>
                {{
                  orders?.find((orderItem) => orderItem.orderNo == item.orderNo)
                    .name
                }}
              </span>
            </td>

            <td
              class="table-td border-r border-opacity-20 flex justify-between items-center"
            >
              <div class="w-1/2 flex items-center">
                <p class="w-1/2">
                  {{ item.vehicle }}
                </p>
                <p class="w-1/2">{{ item.capacity / 1000 }} TON</p>
              </div>
              <div class="w-1/2 flex justify-between items-center">
                <img
                  :title="item.romorkType"
                  v-if="item.capacity / 1000 <= 52 && item.capacity / 1000 > 20"
                  class="w-12 h-8"
                  src="@/assets/vehicles/fuel-truck.png"
                  alt=""
                />
                <img
                  :title="item.romorkType"
                  v-if="item.capacity / 1000 <= 20"
                  class="w-10 h-8"
                  src="@/assets/vehicles/tank-truck.png"
                  alt=""
                />
                <span
                  class="px-2 bg-red-600 rounded-xl text-white text-xs inline-block font-extralight whitespace-nowrap ml-1"
                  v-if="item.isCustom == 1"
                >
                  Manuel Atama
                </span>
              </div>
            </td>

            <td class="table-td border-r border-opacity-20">
              <p>
                {{ item.address + " / " + Money(item?.recomendation.isWashing == 1 && (item?.washPointName != null && item?.washPointName != "")  ? item?.distanceWithWashing : item?.recomendation?.distancePriority) + " KM" }}
              </p>
            </td>

            <td class="table-td border-r border-opacity-20">
              <p>
                {{ item.washPointName }}
              </p>
            </td>

            <td class="table-td border-r border-opacity-20">
              <p v-if="item.washCost >= 0">
                {{ item.washCost }}
              </p>
              <p v-else>Loading...</p>
            </td>

            <td class="table-td border-r border-opacity-20">
              <p v-if="item.recomendationTotalCost >= 0">
                {{ item.recomendationTotalCost }}
              </p>
              <p v-else>Loading...</p>
            </td>

            <td class="table-td border-r border-opacity-20">
              <p v-if="item.allCost >= 0">
                {{ Number(item.allCost).toFixed(2) }}
              </p>
              <p v-else>Loading...</p>
            </td>

            <td v-if="!hiddenInsert" class="flex justify-center items-center">
              <button
                type="button"
                class="process-btn mr-2"
                @click.stop="vehicleDetailItem(item)"
              >
                <i class="fas fa-search"></i>
              </button>
              <button
                type="button"
                class="process-btn"
                @click.stop="deleteItem(item, index)"
              >
                <i class="fas fa-trash"></i>
              </button>
            </td>
          </tr>
          <td
            :colspan="hiddenInsert ? 8 : 9"
            class="text-center p-4 text-white"
            v-if="
              changeState == true &&
              List?.length == 0 &&
              !load &&
              !isRecommendationInProgress
            "
          >
            <i class="fas fa-recycle fa-3x"></i>
            <h3 class="text-2xl mt-2">ARAÇ PLANLA</h3>
            <p class="text-sm my-2 text-white text-opacity-75">
              bu sipariş için araç planlamak için planla butonuna basınız
            </p>
            <div class="space-y-3">
              <button
                v-if="!showRetryButton"
                class="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-200 transform hover:scale-105 shadow-lg"
                type="button"
                @click="() => calculateVehicle()"
                :disabled="isRecommendationInProgress"
              >
                <i v-if="!isRecommendationInProgress" class="fas fa-magic mr-2"></i>
                <i v-if="isRecommendationInProgress" class="fas fa-spinner fa-spin mr-2"></i>
                {{ isRecommendationInProgress ? 'Hesaplanıyor...' : 'Araç Öner' }}
              </button>
              
              <div v-if="showRetryButton" class="space-y-2">
                <div class="bg-red-100 dark:bg-red-900/30 border border-red-300 dark:border-red-600 rounded-lg p-3">
                  <div class="flex items-center text-red-700 dark:text-red-300">
                    <i class="fas fa-exclamation-triangle mr-2"></i>
                    <span class="text-sm font-medium">Bağlantı hatası oluştu</span>
                  </div>
                  <p class="text-xs text-red-600 dark:text-red-400 mt-1">
                    {{ lastError?.message || 'Bilinmeyen hata' }}
                  </p>
                </div>
                
                <button
                  class="bg-gradient-to-r from-orange-500 to-orange-600 hover:from-orange-600 hover:to-orange-700 text-white px-6 py-3 rounded-lg font-semibold transition-all duration-200 transform hover:scale-105 shadow-lg"
                  type="button"
                  @click="retryCalculation"
                  :disabled="isRecommendationInProgress"
                >
                  <i v-if="!isRecommendationInProgress" class="fas fa-redo mr-2"></i>
                  <i v-if="isRecommendationInProgress" class="fas fa-spinner fa-spin mr-2"></i>
                  {{ isRecommendationInProgress ? 'Yeniden Deneniyor...' : 'Yeniden Dene' }}
                </button>
              </div>
            </div>
          </td>
        </tbody>
        <tableLoader
          :load="load || isRecommendationInProgress"
          length="1"
          :colspan="hiddenInsert ? 8 : 9"
        />
      </table>
    </div>
  </div>
</template>

<script>
// NPM
import _ from "lodash";
import similarity from "similarity";

// Global Components
import vehicleModal from "@/components/modals/vehicle.detail.modal/index.vue";
import tableLoader from "@/components/general/table-loader.vue";

// Local Components
import newVehicle from "./new.vehicle.vue";

// Utils
import {
  getCustomers,
  getLocationAll,
  getProducts,
  customer,
} from "@/utils/detailData";
import {
  recommendMultipleVehiclesForOrder,
  calculateDistancePriority,
  calculateCustomerPriority,
  isVehicleSuitableForOrderDetail,
  isWashStatus,
  haversineDistance,
} from "@/utils/recomendation";
import { 
  retryWithBackoff, 
  VEHICLE_API_RETRY_CONFIG, 
  RECOMMENDATION_API_RETRY_CONFIG 
} from "@/utils/retryUtility";
import moment from "moment";

//Axios
import axios from "axios";
import { bulkShipPlanning } from "@/networking/urlmanager";
import VehicleConflictModal from '../../../../../../../components/modals/VehicleConflictModal.vue';

export default {
  name: "vehicle-table",
  props: ["orders", "storageId", "isLaterAddOrder", "totalCount", "haveType", "recomendedCount"],
  components: {
    tableLoader,
    newVehicle,
    vehicleModal,
    VehicleConflictModal,
  },
  data() {
    return {
      isVehicleConflictModalVisible:{show:false,order:{},vehicle:{}},
      activeEror: "",
      load: false,
      changeState: true,
      List: [],
      dedicatedVehicles: [],
      currentVehicles: [],
      vehicleList: [],
      customers: [],
      products: [],
      new: {
        vehicle: "",
        dorse: "",
        driverName: "",
        driverTC: "",
      },
      washingLocations: [],
      insufficientErr: false,
      vehicleArrivalTime: "",
      recAccVehicleCapacity: 0,
      currAccVehicleCapacity: 0,
      isDeleted: false,
      selected: { id: "", plaque: "", vehicleId: "" },
      hiddenInsert: false,
      isManuel: false,
      newOrder: undefined,

      isCalculationInProgress: false,
      isRecommendationInProgress: false,
      debouncedCalculateVehicle: _.debounce(this.calculateVehicle, 300),
      
      // Retry mechanism
      retryCount: 0,
      maxRetries: 3,
      showRetryButton: false,
      lastError: null,
      
      // Bulk selection
      selectedItems: [],
    };
  },

  methods: {
    reset(){
      this.isVehicleConflictModalVisible={show:false,order:{},vehicle:{}};
    },
    // Bulk selection methods
    toggleAllSelection() {
      if (this.allSelected) {
        this.selectedItems = [];
      } else {
        this.selectedItems = this.List.map((item, index) => item.id || index);
      }
    },
    clearSelection() {
      this.selectedItems = [];
    },
    bulkDelete() {
      if (this.selectedItems.length === 0) return;

      this.$swal.fire({
        icon: 'warning',
        title: 'Toplu Silme',
        text: `${this.selectedItems.length} araç silinecek. Emin misiniz?`,
        showCancelButton: true,
        confirmButtonText: 'Evet, Sil',
        cancelButtonText: 'İptal',
        confirmButtonColor: '#dc2626'
      }).then((result) => {
        if (result.isConfirmed) {
          const selectedIds = new Set(this.selectedItems);
          
          // Filter out selected items
          this.List = this.List.filter((item, index) => {
            const itemId = item.id || index;
            return !selectedIds.has(itemId);
          });
          
          // Clear selection
          this.selectedItems = [];
          
          // Emit change
          this.$emit("change", this.List);
          
          this.$swal.fire({
            icon: 'success',
            title: 'Başarılı',
            text: 'Seçilen araçlar silindi.',
            timer: 2000,
            showConfirmButton: false
          });
        }
      });
    },
    // Row selection methods
    toggleRowSelection(item, index, event) {
      // Prevent event propagation to avoid triggering form submissions
      event.preventDefault();
      event.stopPropagation();
      
      // Prevent triggering on interactive elements
      if (event.target.tagName === 'BUTTON' || 
          event.target.tagName === 'INPUT' || 
          event.target.closest('button') ||
          event.target.closest('input')) {
        return;
      }
      
      const itemId = item.id || index;
      const currentIndex = this.selectedItems.indexOf(itemId);
      
      if (currentIndex > -1) {
        this.selectedItems.splice(currentIndex, 1);
      } else {
        this.selectedItems.push(itemId);
      }
    },
    isSelected(item, index) {
      const itemId = item.id || index;
      return this.selectedItems.includes(itemId);
    },
    async calculateVehicle() {
      if (this.isRecommendationInProgress) {
        console.log("calculateVehicle: Calculation is already in progress");
        return;
      }

      console.log("calculateVehicle called for storage");
      this.isRecommendationInProgress = true;
      this.load = true;
      this.showRetryButton = false;
      this.lastError = null;

      try {
        if (this.totalCount < 1) {
          this.swalBox(
            "warning",
            "UYARI!",
            "Araç sayısı en az 1 olmalıdır",
            false,
            "Tamam"
          );
          return;
        }

        // Load data with retry mechanism
        await this.loadRequiredDataWithRetry();

        console.log("Data loaded:", {
          vehicleList: this.vehicleList.length,
          customers: this.customers.length,
          products: this.products.length,
          orders: this.orders?.length || 0
        });

        await this.processOrderItemWithRetry();
        this.changeState = false;
        this.retryCount = 0; // Reset retry count on success
      } catch (error) {
        console.error("calculateVehicle error:", error);
        this.lastError = error;
        this.handleCalculationError(error);
      } finally {
        this.isRecommendationInProgress = false;
        this.load = false;
      }
    },
    async loadRequiredDataWithRetry() {
      // Load vehicle list with retry
      if (this.vehicleList?.length == 0) {
        this.vehicleList = await retryWithBackoff(
          () => getLocationAll(this.$store.state.userData.token),
          {
            ...VEHICLE_API_RETRY_CONFIG,
            onRetry: (error, attempt, delay) => {
              this.swalBox(
                "info",
                "VERİ YÜKLENİYOR",
                `Araç listesi yüklenirken hata oluştu. ${attempt}. deneme yapılıyor...`,
                false,
                "Tamam"
              );
            }
          }
        );
      }
      
      // Load customers with retry
      if (this.customers?.length == 0) {
        this.customers = await retryWithBackoff(
          () => getCustomers(this.$store.state.userData.token),
          VEHICLE_API_RETRY_CONFIG
        );
      }
      
      // Load products with retry
      if (this.products?.length == 0) {
        this.products = await retryWithBackoff(
          () => getProducts(this.$store.state.userData.token),
          VEHICLE_API_RETRY_CONFIG
        );
      }
    },
    async processOrderItemWithRetry() {
      await retryWithBackoff(
        () => this.processOrderItem(),
        {
          ...RECOMMENDATION_API_RETRY_CONFIG,
          onRetry: (error, attempt, delay) => {
            this.swalBox(
              "info",
              "ARAÇ ÖNERİSİ",
              `Araç önerisi hesaplanırken hata oluştu. ${attempt}. deneme yapılıyor...`,
              false,
              "Tamam"
            );
          }
        }
      );
    },
    handleCalculationError(error) {
      this.retryCount++;
      
      if (this.retryCount < this.maxRetries) {
        this.showRetryButton = true;
        this.swalBox(
          "warning",
          "BAĞLANTI HATASI",
          `Araç önerisi hesaplanırken bir hata oluştu. Tekrar denemek için "Yeniden Dene" butonuna tıklayın.\n\nHata: ${error.message}`,
          false,
          "Tamam"
        );
      } else {
        this.swalBox(
          "error",
          "HATA!",
          `${this.maxRetries} deneme sonrası araç önerisi hesaplanamadı. Lütfen internet bağlantınızı kontrol edin ve daha sonra tekrar deneyin.\n\nHata: ${error.message}`,
          false,
          "Tamam"
        );
      }
    },
    async retryCalculation() {
      this.showRetryButton = false;
      await this.calculateVehicle();
    },
    async processOrderItem() {
      if (!this.orders || this.orders.length === 0) {
        this.swalBox(
          "warning",
          "UYARI!",
          "Önce sipariş eklemeniz gerekmektedir.",
          false,
          "Tamam"
        );
        return;
      }

      // Clear existing list
      this.List = [];

      // Process each order
      for (const order of this.orders) {
        await this.processOrder(order);
      }

      this.$emit("change", this.List);
    },
    async processOrder(order) {
      const vehicleCount = order.recomendedCount || 1;
      
      console.log("Processing order:", {
        order: order,
        vehicleCount: vehicleCount,
        customersLength: this.customers?.length,
        productsLength: this.products?.length,
        vehicleListLength: this.vehicleList?.length
      });
      
      // Ensure productId is set for the order
      if (!("productId" in order) || order.productId === undefined) {
        const product = this.products.find((product) => product.name.trim() === order.productType?.trim());
        if (product) {
          order.productId = product.id;
        }
      }
      
      console.log("Order with productId:", order);

      // Sadece aktif araçları blockedVehicles olarak gönder
      // Durdurulup salınan araçlar (isStopped = 1 veya isReleasedFromShip = 1) hariç tutulur
      const activeVehiclesOnly = this.List.filter(vehicle => {
        // Eğer araç durdurulmuş veya serbest bırakılmışsa, blockedVehicles'a ekleme
        return !(vehicle.isStopped === 1 || vehicle.isReleasedFromShip === 1);
      });

      const recommendedVehicles = await recommendMultipleVehiclesForOrder(
        order,
        this.vehicleList,
        this.customers,
        this.products,
        vehicleCount,
        activeVehiclesOnly, // Sadece aktif araçları gönder
        true,  // isBulk
        false,  // skipTheTonnage
        true,   // setAvailable
        [],     // blockedVehiclesParam
        false,  // isClose
        this.$store.state.userData.token
      );

      if (recommendedVehicles.length === 0) {
        this.handleNoRecommendedVehicles();
        return;
      }

      if (recommendedVehicles.length < vehicleCount) {
        this.handleInsufficientVehicles(recommendedVehicles, vehicleCount);
      }

      // Filo kontrolü - Chryso gibi özel filolara ait araçlar için uyarı
      const newDedicatedVehicles = this.getNewDedicatedVehicles(recommendedVehicles, order);

      if (newDedicatedVehicles.length) {
        await this.handleDedicatedVehicles(
          newDedicatedVehicles,
          recommendedVehicles,
          order,
          vehicleCount
        );
      } else {
        this.addRecommendedVehiclesToList(recommendedVehicles, order);
      }
    },
    addRecommendedVehiclesToList(vehicles, order) {
      vehicles.forEach((vehicle) => {
        const vehicleItem = {
          ...vehicle,
          orderNo: order.orderNo,
          orderName: order.orderName || order.customer,
          capacity: vehicle.capacity || 0,
          isCustom: 0,
          allCost: vehicle.recomendationTotalCost || 0,
          washCost: vehicle.washCost || 0,
          recomendationTotalCost: vehicle.recomendationTotalCost || 0,
          address: vehicle.address || "",
          distance: vehicle.distance || 0,
          washPointName: vehicle.washPointName || "",
          recomendation: vehicle.recomendation || {}
        };
        
        this.List.push(vehicleItem);
      });
    },
    handleNoRecommendedVehicles() {
      this.swalBox(
        "warning",
        "UYARI!",
        "Bu sipariş için Uygun araç bulunamadı.",
        false,
        "Tamam"
      );
    },
    handleInsufficientVehicles(recommendedVehicles, requestedCount) {
      this.swalBox(
        "warning",
        "UYARI!",
        `Bu iş için girilen araç sayısı ${requestedCount} ama müsait araç sayısı ${recommendedVehicles.length} olduğu için araç sayısı güncellendi.`,
        false,
        "Tamam"
      );
    },

    getNewDedicatedVehicles(recommendedVehicles, order) {
      return recommendedVehicles.filter(
        (item) =>
          item.fleetCustomers &&
          item.fleetCustomers.length &&
          !item.fleetCustomers.some(
            (customer) => customer?.customerId === order?.customerId
          )
      );
    },

    async handleDedicatedVehicles(
      newDedicatedVehicles,
      recommendedVehicles,
      order,
      vehicleCount,
      previouslyBlockedVehicles = []
    ) {
      // Filo gruplarını oluştur
      const groupedData = newDedicatedVehicles.reduce((acc, item) => {
        item.fleetCustomers.forEach((customer) => {
          if (!acc[customer?.customerName]) {
            acc[customer?.customerName] = [];
          }
          acc[customer?.customerName].push(item.plate || item.vehicle);
        });
        return acc;
      }, {});

      const tableData = Object.entries(groupedData).map(
        ([customerName, vehicles]) => ({
          customerName,
          vehicles: vehicles.join(", "),
        })
      );

      const result = await this.$swal.fire({
        icon: "warning",
        title: "FİLO UYARISI !",
        showConfirmButton: true,
        showCancelButton: true,
        confirmButtonText: "Devam et",
        cancelButtonText: "Yeniden Öner",
        width: "800px",
        html: `
            <div>
              <div>
                <span class="block text-lg font-semibold mb-4">Önerilen araç listesinde başka müşteriye atanmış filoya ait araçlar var:</span>
              </div>
              <div class="overflow-x-auto">
                <table class="min-w-full bg-white border border-gray-200">
                  <thead>
                    <tr class="w-full bg-gray-200 text-left text-sm leading-normal text-gray-600 uppercase tracking-wider">
                      <th class="py-3 px-6 border-r border-gray-200">Müşteri</th>
                      <th class="py-3 px-6">Araçlar</th>
                    </tr>
                  </thead>
                  <tbody class="text-gray-700">
                    ${tableData
                      .map(
                        (row) => `
                      <tr class="border-b border-gray-200 hover:bg-gray-100">
                        <td class="py-3 px-6 border-r border-gray-200">${row.customerName}</td>
                        <td class="py-3 px-6">${row.vehicles}</td>
                      </tr>
                    `
                      )
                      .join("")}
                  </tbody>
                </table>
              </div>
              <div class="mt-4 text-sm text-gray-600">
                <p>"Yeniden Öner" seçeneğini seçerseniz, sistem bu araçları hariç tutarak yeni araç önerisi yapacaktır.</p>
              </div>
            </div>
          `,
      });

      if (!result.isConfirmed) {
        // Kullanıcı "Yeniden Öner" dedi - filo araçlarını bloke et
        // Sadece aktif araçları blockedVehicles olarak gönder
        const activeVehiclesOnly = this.List.filter(vehicle => {
          return !(vehicle.isStopped === 1 || vehicle.isReleasedFromShip === 1);
        });

        // Önceden bloke edilmiş araçları + mevcut listeyi + yeni filo araçlarını birleştir
        const allBlockedVehicles = [
          ...previouslyBlockedVehicles, // Önceki çağrılarda bloke edilenler
          ...activeVehiclesOnly,         // Mevcut listedeki araçlar
          ...newDedicatedVehicles        // Şu an reddedilen filo araçları
        ];

        const newRecommendedVehicles = await recommendMultipleVehiclesForOrder(
          order,
          this.vehicleList,
          this.customers,
          this.products,
          vehicleCount,
          allBlockedVehicles,
          true,  // isBulk
          false,  // skipTheTonnage
          true,   // setAvailable
          [],     // blockedVehiclesParam
          false,  // isClose
          this.$store.state.userData.token
        );

        if (newRecommendedVehicles.length > 0) {
          // Yeni önerilerde de filo kontrolü yap (recursive)
          const newDedicated = this.getNewDedicatedVehicles(newRecommendedVehicles, order);
          if (newDedicated.length) {
            await this.handleDedicatedVehicles(
              newDedicated,
              newRecommendedVehicles,
              order,
              vehicleCount,
              allBlockedVehicles // ✅ Tüm bloke edilmiş araçları bir sonraki çağrıya aktar
            );
          } else {
            this.addRecommendedVehiclesToList(newRecommendedVehicles, order);
          }
        } else {
          this.swalBox(
            "warning",
            "UYARI!",
            "Filo kısıtlaması nedeniyle yeni araç önerisi bulunamadı. Lütfen manuel olarak araç ekleyin.",
            false,
            "Tamam"
          );
        }
      } else {
        // Kullanıcı "Devam et" dedi - tüm araçları ekle
        this.addRecommendedVehiclesToList(recommendedVehicles, order);
      }
    },

    addItem(item) {
      if (item) {
        const order = this.orders?.find(
          (orderItem) => orderItem.orderNo == item.orderNo
        );
        const findProduct = this.products.find((pValue) => {
          return (
            similarity(
              pValue?.name?.toString().toLocaleLowerCase().replace(/\s/g, ""),
              order?.productType
                ?.toString()
                .toLocaleLowerCase()
                .replace(/\s/g, "")
            ) >= 0.8
          );
        });
        if (findProduct?.typeId === 2) {
          //  Araçta bu dorse türü olup olmadığını kontrol et
          const findDorseType = findProduct.dorseTypes.filter((find) => {
            if (
              typeof find.name == "string" &&
              typeof item.romorkType == "string"
            ) {
              if (
                similarity(
                  find?.name.toLowerCase().replace(/\s/g, ""),
                  item?.romorkType?.toLowerCase().replace(/\s/g, "")
                ) > 0.85
              ) {
                return find;
              }
            }
          });

          const allADRDorse = item?.romorkType?.includes("ADR");
          const ADRVehicle = item?.transportPurpose?.includes("TEHLİKELİ");

          if (!allADRDorse || !ADRVehicle || findDorseType.length < 1) {
            this.$swal
              .fire({
                icon: "warning",
                title: this.$t("general.warningTitle"),
                text: "Uygun olmayan araç",
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: this.$t("general.confirmText"),
                cancelButtonText: this.$t("general.rejectText"),
                customClass: {
                  popup: "w-1/2",
                },
                html: `<div class="flex flex-col items-center">
                ${
                  findDorseType.length < 1
                    ? `<span class="w-full">
                      Bu araç bu ürünü taşımak için uygun bir dorseye sahip
                      değildir!
                    </span>`
                    : ""
                }
                ${
                  !allADRDorse
                    ? `<span class="w-full">
                      Bu aracın dorsesi tehlikeli ürün taşımaya uygun değildir!
                    </span>`
                    : ""
                }
                ${
                  !ADRVehicle
                    ? `<span class="w-full">
                      Bu çekici tehlikeli ürün taşımaya uygun değildir!
                    </span>`
                    : ""
                }
                <br/>
                <span class="w-full">Devam etmek istediğinize emin misiniz?</span>
                </div>`,
              })
              .then((acc) => {
                if (acc.isConfirmed) {
                  this.addVehicle(item);
                }
              });
          } else {
            this.addVehicle(item);
          }
        } else {
          this.addVehicle(item);
        }
      }
    },
    addVehicle(item) {
      this.insufficientErr = false;
      let index = this.List.some((r) => parseInt(r.id) == parseInt(item.id));
      if (!index) {
        this.isDeleted = true;
        this.isManuel = true;

        const vehicleIndex = this.vehicleList.findIndex(
          (vitem) => vitem.id == item.id
        );

        const order = this.orders?.find(
          (orderItem) => orderItem.orderNo == item.orderNo
        );

        this.vehicleList[vehicleIndex].orderNos = [item.orderNo];
        const distancePriority = calculateDistancePriority(
            { startLat: item.outpointLat, startLng: item.outpointLng },
            { latitude: item.latitude, longitude: item.longitude }
          );
        this.List.push({
          ...item,
          plate: item.name,
          vehicle: item.name,
          latitude: Number(item.latitude),
          longitude: Number(item.longitude),
          isRent: item?.haveType ?? item?.isRent,
          distance: distancePriority,
          isCustom: 1,
          recomendation: {
            isWashing: isWashStatus(this.customers, this.products, item, order)
              .status,
            distancePriority: distancePriority
          },
        });

        this.$emit("addVehicle", true);

        setTimeout(() => {
          this.isDeleted = false;
          this.isManuel = false;
        }, 50);
      } else {
        this.swalBox(
          "warning",
          this.$t("general.warningTitle"),
          "Bu Araç Zaten Listede Var",
          false,
          this.$t("general.OkayTitle")
        );
      }
    },
    deleteItem(detail, index) {
      this.$swal.fire({
        icon: 'warning',
        title: 'Araç Çıkarma',
        text: 'Aracı listeden çıkarmak istediğinize emin misiniz?',
        showCancelButton: true,
        confirmButtonText: 'Evet, Çıkar',
        cancelButtonText: 'İptal',
        confirmButtonColor: '#dc2626'
      }).then((result) => {
        if (result.isConfirmed) {
          this.List.splice(index, 1);
          this.$emit("change", this.List);
        }
      });
    },
    vehicleDetailItem(item) {
      const { latitude, longitude, ...rest } = item;
      const order = this.orders?.find(
        (orderItem) => orderItem.orderNo == item.orderNo
      );
      if (item.isCustom == 2) {
        this.selected = {
          outpointLng: Number(order.outpointLng),
          outpointLat: Number(order.outpointLat),
          targetPointLat: Number(order.targetPointLat),
          targetPointLng: Number(order.targetPointLng),
          ...rest,
          tonnage: item.recomendation.capacity,
          orderAmount: Number(order.amount),
          recomendation: {
            ...item.recomendation,
            position: { lat: latitude, lng: longitude },
          },
        };
      } else {
        this.selected = {
          outpointLng: Number(
            order.outpointLng ? order.outpointLng : order.fillingLongitude
          ),
          outpointLat: Number(
            order.outpointLat ? order.outpointLat : order.fillingLatitude
          ),
          targetPointLat: Number(
            order.targetPointLat ? order.targetPointLat : order.deliveryLatitude
          ),
          targetPointLng: Number(
            order.targetPointLng
              ? order.targetPointLng
              : order.deliveryLongitude
          ),
          ...rest,
          tonnage: item.capacity,
          orderAmount: Number(order.amount),
          recomendation: {
            ...item.recomendation,
            name: item.vehicle,
            position: { lat: latitude, lng: longitude },
            capacity: item.capacity,
            customerPriority: calculateCustomerPriority(order, this.customers),
            distancePriority: calculateDistancePriority(
              {
                startLat: Number(
                  order.outpointLat ? order.outpointLat : order.fillingLatitude
                ),
                startLng: Number(
                  order.outpointLng ? order.outpointLng : order.fillingLongitude
                ),
              },
              { latitude: latitude, longitude: longitude }
            ).toFixed(2),
            ...isVehicleSuitableForOrderDetail(
              order,
              item,
              this.products,
              false,
              false
            ),
          },
        };
      }
      this.$modal.show("vehicle-modal");
    },
    Money(value) {
      return parseFloat(value).toFixed(2);
    },
    async save(callback) {
      try {
        const list = this.List.map((item) => {
          return {
            orderNo: item.orderNo,
            orderName: item.orderName,
            vehicle: item.vehicle,
            plate: item.vehicle,
            dorse: item.dorse,
            driverName: item.driverName,
            isCustom: item.isCustom || 0,
            driverTC: item.driverTC,
            capacity: item.capacity,
          };
        });

        if (list.length > 0) {
          await axios.post(
            bulkShipPlanning.vehicleBulkAdd,
            {
              vehicleList: JSON.stringify(list),
              shipId: this.storageId,
              isLaterAddOrder: this.isLaterAddOrder,
            },
            {
              headers: {
                Authorization: "Bareer " + this.$store.state.userData.token,
              },
            }
          );
          callback(true);
        } else {
          this.swalBox(
            "warning",
            this.$t("general.warningTitle"),
            "Devam etmek için araç eklemeniz gerekmektedir.",
            false,
            this.$t("general.OkayTitle")
          );
          callback(false);
        }
      } catch (err) {
        this.errorBox(err.response);
        callback(false);
      }
    },
    swalBox(icon, title, text, showCancel, confirmText) {
      return this.$swal.fire({
        icon: icon,
        title: title,
        text: text,
        showCancelButton: showCancel,
        confirmButtonText: confirmText
      });
    },
    errorBox(response) {
      let message = "Bir hata oluştu";
      if (response && response.data && response.data.message) {
        message = response.data.message;
      } else if (response && response.message) {
        message = response.message;
      }
      
      console.error("Error details:", response);
      
      this.swalBox("error", "HATA!", message, false, "Tamam");
    },
  },
  computed: {
    isMultipleDay() {
      return false; // Simple implementation
    },
    allSelected() {
      return this.List.length > 0 && this.selectedItems.length === this.List.length;
    },
  },
  async created() {
    this.changeState = this.calculateState != true;
    this.load = true;

    if (this.vehicleList.length == 0) {
      this.vehicleList = await getLocationAll(this.$store.state.userData.token);
    }
    if (this.customers.length == 0)
      this.customers = await getCustomers(this.$store.state.userData.token);
    if (this.products.length == 0)
      this.products = await getProducts(this.$store.state.userData.token);
    
    this.load = false;
  },
  watch: {
    List(val) {
      this.$emit("change", val);
      // Clear selection when list changes
      this.selectedItems = this.selectedItems.filter((selectedId) => {
        return val.some((item, index) => (item.id || index) === selectedId);
      });
    },
  },
};
</script>